/**
 *   This is a service for a specific store module.
 *   We separate our files for easy managment and readibility.
 *   We export this as a service to be used in other areas of the application.
 */
import Api from '@/services/api';

export default {

  async searchCareers(params: {
    category?: string, 
    subCategoryId?: string, 
    classificationIdUno?: string, 
    classificationIdDos?: string, 
    keyword?: string,
  }) {
    return Api().post('/search/careers', params);
  },
  
};
